import React, { useRef } from 'react';
import './TradeRoom.css';

const CustomExpirationInput = ({ value, onChange, min = 1, max = 60, placeholder = '', disabled = false }) => {
  const inputRef = useRef();
  const handleStep = (delta) => {
    if (disabled) return;
    let newValue = Number(value) + delta;
    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;
    onChange({ target: { value: newValue } });
  };
  // Обработка ручного ввода
  const handleInput = (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    onChange({ target: { value: raw } });
  };
  const isFocused = inputRef.current && document.activeElement === inputRef.current;
  return (
    <div className={`custom-input-outer${isFocused ? ' focused' : ''}`}>
      <input
        ref={inputRef}
        type="text"
        className="custom-input custom-expiration-input"
        min={min}
        max={max}
        value={value ? `${value} sec` : ''}
        onChange={handleInput}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        inputMode="numeric"
      />
      <span className={`custom-input-arrows${isFocused ? ' focused' : ''}`}>
        <span className="custom-arrow-up" onClick={() => handleStep(1)} tabIndex={-1} role="button">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 4L14 11H4L9 4Z" fill="white"/></svg>
        </span>
        <span className="custom-arrow-divider" />
        <span className="custom-arrow-down" onClick={() => handleStep(-1)} tabIndex={-1} role="button">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 14L4 7H14L9 14Z" fill="white"/></svg>
        </span>
      </span>
    </div>
  );
};

export default CustomExpirationInput; 